import React from "react";
import Header from "./Header";
import SideBar, { SideBarToggle } from "./SideBar";
import "./Layout.css";

interface LayoutProps {
  children: React.ReactNode;
  sidebarOpen: boolean;
  toggleSidebar: () => void;
  containerClass?: string;
  contentClass?: string;
}

const Layout: React.FC<LayoutProps> = ({
  children,
  sidebarOpen,
  toggleSidebar,
  containerClass = "",
  contentClass = "",
}) => {
  return (
    <div className={`app-layout ${containerClass}`.trim()}>
      <SideBarToggle toggleSidebar={toggleSidebar} isOpen={sidebarOpen} />
      <SideBar isOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
      <Header toggleSidebar={toggleSidebar} />
      <main className={`app-main ${contentClass}`.trim()}>
        {children}
      </main>
      <footer className="app-footer">
        <p>© 2025 Aloja Fácil - Todos los derechos reservados</p>
      </footer>
    </div>
  );
};

export default Layout;
